import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import ContactForm from './ContactForm';

const styles = css`
  text-align: center;
  .Contact_wrapper {
    padding: 30px 0;

    div {
      margin-left: 0;
      margin-right: 0;
    }
  }
  @media(min-width: 992px) {
    text-align: left;

    .Contact_wrapper {
      padding: 90px 0;
    }
  }
`;

const formStyles = css`
  .form-row {
    .col {
      padding: 0 15px;
    }
  }
`;

function ContactUsContent({ page }) {
  return (
    <div className={styles}>
      <div className="container Contact_wrapper">
        <div className="row">
          <div className="col-lg-3">
            <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'more_information'))} />
          </div>
          <div className="col-lg-8 ml-auto">
            <ContactForm className={formStyles} />
          </div>
        </div>
      </div>
    </div>
  );
}

ContactUsContent.propTypes = {
  page: PropTypes.object.isRequired,
};

export default ContactUsContent;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContactUsContent.js